import React from 'react';
import { useDispatch, useSelector } from 'react-redux';


import { signOutStart } from '../../redux/user/user.actions';


import { HeaderContainer, LogoContainer, OptionsContainer, 
        OptionLink, OptionText, NavContainer} from './headerNR.styles';





const HeaderNR = () => {

    const currentUser = useSelector(state => state.user.currentUser);
    const dispatch = useDispatch();

    let name = " ";
    if (currentUser !== null) {
        if(currentUser.firstName)    {    
            name = `Welcome, ${currentUser.firstName.toUpperCase()}!`;
        }
    
        return (
            <HeaderContainer> 
                <LogoContainer>
                        <img id="logo" alt="logo"  src={require("../../assets/mrsLogo.png")} height="auto" width="100%" />

                </LogoContainer>
                <NavContainer>
                    <OptionsContainer>
                        <OptionLink as='div' onClick={() => dispatch(signOutStart())}>SIGN OUT</OptionLink>
                    </OptionsContainer>
                    <OptionsContainer>
                        <OptionText>{name}</OptionText>
                    </OptionsContainer>
                </NavContainer>
            </HeaderContainer>
        );
    }
    return (
        null
    );
    
};

export default HeaderNR;